// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-drawer .ant-drawer-mask {
	background: none !important;
}

.drawer_main .heading_close_otr {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 13px;
	box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 4px;
	background-color: var(--white-color);
	border: none;
	position: relative;
	z-index: 2;
}
@media (max-width: 575px) {
	.drawer_main .heading_close_otr {
		/* padding: 10px 13px !important; */
	}
}
.drawer_main .heading_close_otr .modal_heading {
	color: var(--black-color);
	font-family: "Poppins", sans-serif;
	height: 13px;
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0.1em;
	text-transform: uppercase;
}
@media (max-width: 575px) {
	.drawer_main .heading_close_otr .modal_heading {
		height: auto !important;
	}
}

.ant-drawer .ant-drawer-mask {
    background: none !important;
}

.drawer_main .heading_close_otr .close_icon_otr {
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	margin: 0;
	padding: 0;
	height: auto;
	outline: none;
}
.drawer_main .heading_close_otr svg {
	width: 20px;
	height: 20px;
}

.drawer_main .heading_close_otr svg path {
	fill: var(--dark-text-color);
}

.drawer_main .ant-drawer-body {
	padding: 0;
}

.appointment-date-picker {
	position: relative;
	height: 100%;
}

.spinner-container,
.error-container {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 50;
}

.error-container {
	color: red;
	font-weight: 600;
	z-index: 0;
}
.error-message {
	color: red;
	margin: 8px 0px;
	font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,aAAa;CACb,2CAA2C;CAC3C,oCAAoC;CACpC,YAAY;CACZ,kBAAkB;CAClB,UAAU;AACX;AACA;CACC;EACC,mCAAmC;CACpC;AACD;AACA;CACC,yBAAyB;CACzB,kCAAkC;CAClC,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,YAAY;CACZ,aAAa;AACd;AACA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;;CAEC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,0CAA0C;CAC1C,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,UAAU;CACV,eAAe;CACf,gBAAgB;AACjB","sourcesContent":[".ant-drawer .ant-drawer-mask {\n\tbackground: none !important;\n}\n\n.drawer_main .heading_close_otr {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 13px;\n\tbox-shadow: rgba(0, 0, 0, 0.05) 0px 4px 4px;\n\tbackground-color: var(--white-color);\n\tborder: none;\n\tposition: relative;\n\tz-index: 2;\n}\n@media (max-width: 575px) {\n\t.drawer_main .heading_close_otr {\n\t\t/* padding: 10px 13px !important; */\n\t}\n}\n.drawer_main .heading_close_otr .modal_heading {\n\tcolor: var(--black-color);\n\tfont-family: \"Poppins\", sans-serif;\n\theight: 13px;\n\tfont-weight: 600;\n\tfont-size: 12px;\n\tline-height: 16px;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n}\n@media (max-width: 575px) {\n\t.drawer_main .heading_close_otr .modal_heading {\n\t\theight: auto !important;\n\t}\n}\n\n.ant-drawer .ant-drawer-mask {\n    background: none !important;\n}\n\n.drawer_main .heading_close_otr .close_icon_otr {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: none;\n\tmargin: 0;\n\tpadding: 0;\n\theight: auto;\n\toutline: none;\n}\n.drawer_main .heading_close_otr svg {\n\twidth: 20px;\n\theight: 20px;\n}\n\n.drawer_main .heading_close_otr svg path {\n\tfill: var(--dark-text-color);\n}\n\n.drawer_main .ant-drawer-body {\n\tpadding: 0;\n}\n\n.appointment-date-picker {\n\tposition: relative;\n\theight: 100%;\n}\n\n.spinner-container,\n.error-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: rgba(255, 255, 255, 0.8);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 50;\n}\n\n.error-container {\n\tcolor: red;\n\tfont-weight: 600;\n\tz-index: 0;\n}\n.error-message {\n\tcolor: red;\n\tmargin: 8px 0px;\n\tfont-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
